module.exports = __webpack_public_path__ + "img/phone.ddba58a7.svg";